/**
 * @returns {string} language code
 */
export const getLanguageCode = () => {
  const language = localStorage.getItem("language");
  if (language && language.trim() !== "") {
    return language;
  }
  return null;
};

export const getTheme = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "light" || theme === "dark") {
    return theme;
  }
  localStorage.setItem("theme", "light");
  return "light";
};
